export default (axios, baseURL) => async (excursionId, params, queryParams) => {
  const url = `/v2/excursions/${excursionId}/config`;
  let querystring = '';

  if (queryParams) {
    querystring = Object.keys(queryParams)
      .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
      .join('&');
  }

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url: querystring ? `${url}?${querystring}` : url,
    params
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
